export * from './DatabasesModule'
export const databasesPath = '/et/company/:companyId/databases'
